import(/* webpackMode: "eager", webpackExports: ["CharterCta"] */ "/var/www/light_of_empire_front/widgets/Landing/components/CharterCta/CharterCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingCombatOperations"] */ "/var/www/light_of_empire_front/widgets/Landing/components/LandingCombatOperations/LandingCombatOperations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingHero"] */ "/var/www/light_of_empire_front/widgets/Landing/components/LandingHero/LandingHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNews"] */ "/var/www/light_of_empire_front/widgets/Landing/components/LandingNews/LandingNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServerStatus"] */ "/var/www/light_of_empire_front/widgets/Landing/components/ServerStatus/ServerStatus.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Landing/Landing.module.scss");
